import 'selectize';

import '../select-plugins/clear_selection';

export function watchDriverSelectizeTyping(index) {
  const st = $('#st-number').text();
  const selectize = $(
    `#reservation_container_reservation_container_trips_attributes_${index}_schedule_attributes_driver_id`
  );
  selectize[0].selectize.off('type');
  selectize[0].selectize.on('type', (value) => {
    const service_provider_id =
      $(
        `#reservation_container_reservation_container_trips_attributes_${index}_schedule_attributes_service_provider_id`
      ).val() || '';
    const pricing_id = $(
      `#reservation_container_reservation_container_trips_attributes_${index}_schedule_attributes_financial_service_provider_id`
    ).val();
    if (value.length > 2) {
      $.getJSON(
        `/drivers.json?search=${encodeURIComponent(
          value
        )}&service_provider_id=${service_provider_id}&pricing_id=${pricing_id}&st=${encodeURIComponent(
          st
        )}`,
        (res) => {
          // O ramo antigo para "sem transportadora" montava `{ value, text }`,
          // mas este selectize le `valueField: 'id'` e `labelField:
          // 'name_document'` - a opcao entrava sem valor e nao dava para
          // escolher. O JSON ja vem com as duas chaves certas.
          selectize[0].selectize.clearOptions();
          selectize[0].selectize.addOption(res);
          selectize[0].selectize.refreshOptions();
        }
      );
    }
  });
}

export function driverSelectize() {
  $('select.selectize-driver').each((_i, elem) => {
    const $elem = $(elem);
    if (!$elem[0].selectize) {
      $elem.selectize({
        placeholder: 'Motorista...',
        selectOnTab: true,
        valueField: 'id',
        labelField: 'name_document',
        searchField: ['name_document'],
        plugins: {
          clear_selection: {},
        },
      });
    }
  });
}
